module.exports = __webpack_public_path__ + "static/media/pro-landingpage-expandingto.ea5dc30c.webp";